<rs-web-card [hover]="true" [elevation]="2">
  <rs-web-status-badge class="d-block mb-2" [state]="ticket().state"></rs-web-status-badge>
  <div class="d-flex align-items-center gap-2">
    <rs-web-label
      [text]="
        ticket().category?.name ||
        ticket().title ||
        ('tickets.issue_from.' + ticket().issueType.toLowerCase() | translate) +
          ' ' +
          (displayDate() | date: 'dd.MM.yyyy')
      "
      class="h4 primary-text ticket-name"
    ></rs-web-label>
    @if (ticket()?.hasUnreadMessages) {
      <span class="unread-dot"></span>
    }
  </div>
  <hr />
  <div class="d-flex flex-column gap-2">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-start">
        <rs-web-icon [icon]="immomioIconName.Calendar" [size]="20"></rs-web-icon>
        <div class="primary-text ms-2">{{ displayDate() | date: 'EEEEEE dd.MM.yyyy' }}</div>
      </div>
      @if (canArchive()) {
        <div class="ticket-card__archive-action" (click)="$event.stopPropagation()">
          <a im-button (click)="onArchive()">
            <i iconStart [class]="'icon-' + immomioIconName.Archive"></i>
            {{ 'archive.ticket_a' | translate }}
          </a>
        </div>
      }
    </div>
    @if (ticket().externalId; as externalId) {
      <div class="d-flex align-items-start">
        <rs-web-icon [icon]="immomioIconName.Ticket" [size]="20"></rs-web-icon>
        <rs-web-label
          [text]="'ticket.ticket_id' | translate"
          className="primary-text p-r-5 ms-2"
        ></rs-web-label>
        <rs-web-label [text]="externalId" className="primary-text"></rs-web-label>
      </div>
    }
  </div>
</rs-web-card>
